export const initialState = {
    loading: true,
    approvalProcessSteps: null,
    identificationDetails: null,
    refreshCount: 0,
    showFtmMap: false
}